// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import './rem'
import axios from 'axios'
// import Vconsole from 'vconsole'
import weui from 'weui.js'
import 'weui'
import Carousel3d from 'vue-carousel-3d'
import lazyPng from "./static/imgs/lazy.png"

import Mui from 'vue-awesome-mui';
Vue.config.productionTip = false
import plus from 'vue-h5-plus'
Vue.use(plus)

// window.addEventListener("popstate", function(e) {
//   sessionStorage.clear();
//   WeixinJSBridge.call('closeWindow');
import VueLazyload from 'vue-lazyload'
Vue.config.ignoredElements = ['wx-open-launch-weapp']
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '',
  loading: lazyPng,
  attempt: 1
})
Vue.use(Carousel3d)
Vue.use(Mui);
// Vue.use(VueJsonp)

// Vue.use(vConsole)
Vue.prototype.$weui = weui
Vue.prototype.$wx = window.wx

Vue.prototype.$axios = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js